/* jshint esversion: 6, -W097 */
/* globals module */
'use strict';

/**
 * A service to help manage when modals are open or not.
 *
 * NOTE: This service, because it deals with the `$uibModal` service and doing
 * some slight DOM manipulations to the DOM, is an exception to the norm.
 * We want to shy away from DOM manipulation in services and controllers as
 * much as possible.
 *
 * @module enervee_utils.common
 */
ModalService.$inject = ['$q', '$uibModal'];
function ModalService($q, $uibModal) {
    var _pub = {};
    _pub.currentModals = {};
    _pub.modalIsOpen = false;

    /**
     * Helper function to allow for other services to set when a modal
     * is open.
     *
     * @param {String} modalName
     * @param {String} mainContentSelector the selector for the
     * element(s) that should be hidden from screen readers until all
     * modals are closed
     */
    _pub.setModalIsOpen = function (modalName, mainContentSelector) {
        _pub.currentModals[modalName] = _pub.currentModals[modalName] || {};
        _pub.currentModals[modalName].appendedTo = mainContentSelector;
        // TODO: update aria-hidden attributes for all the siblings of the modal
        _pub.currentModals[modalName].isOpen = true;
        ariaHideElement(mainContentSelector);
        updateModalIsOpen();
    };

    /**
     * Helper function to allow for other services to set when a modal
     * is closed.
     *
     * @param {String} modalName
     */
    _pub.setModalIsClosed = function (modalName) {
        _pub.currentModals[modalName] = _pub.currentModals[modalName] || {};
        // TODO: re-show the siblings that have been aria-hidden
        _pub.currentModals[modalName].isOpen = false;
        var mainContentSelector = _pub.currentModals[modalName].mainContentSelector;
        ariaShowElement(mainContentSelector);
        updateModalIsOpen();
    };

    /**
     * Helper function to wrap around opening a modal with $uibModal,
     * in order to track which modals are open, if any at all.
     *
     * @param {String} modalName the modal's name, for tracking
     * @param {Object} modalConfig the modal options that would
     * noramlly be passed directly to $uibModal.open
     * @return {$uibModal.modalInstance}
     */
    _pub.openModal = function (modalName, modalConfig) {
        var modalInstance = $uibModal.open(modalConfig);
        var appendedToSelector = modalConfig.mainContentSelector || 'div[ui-view]';
        modalInstance.opened.then(function () {
            _pub.setModalIsOpen(modalName, appendedToSelector);
        });

        modalInstance.closed.then(function () {
            _pub.setModalIsClosed(modalName);
        });

        return modalInstance;
    };

    function ariaShowElement(selector) {
        var element = angular.element(selector);
        var modalsStillOpenWithSelector = false;
        angular.forEach(_pub.currentModals, function (modalName, modalConfig) {
            var configElement = angular.element(modalConfig.mainContentSelector);
            if (configElement[0] === element[0]) {
                modalsStillOpenWithSelector = true;
            }
        });
        if (!modalsStillOpenWithSelector) {
            element.attr('aria-hidden', 'false');
        }
    }

    function ariaHideElement(selector) {
        var element = angular.element(selector);
        element.attr('aria-hidden', 'true');
    }

    /**
     * Helper function to update the value of the `modalIsOpen` boolean
     * based on the state of the current modals.
     */
    function updateModalIsOpen() {
        var modalIsOpen = false;
        angular.forEach(_pub.currentModals, function(modalName, modalProps) {
            if (modalProps.isOpen) {
                modalIsOpen = true;
            }
        });
        _pub.modalIsOpen = modalIsOpen;
    }

    return _pub;
}

module.exports = ModalService;